import React from "react";
import styled from "styled-components";
import FormButtons from "src/components/CreditRatingForm/FormButtons";
import { StepControls } from "src/components/CreditRatingStepWizard/CreditRatingStepWizard";

const Description = styled("div")`
    color: ${(props) => props.theme.palette.grey[80]};
    font-size: 14px;
    margin: 0 auto 30px;
    text-align: center;
    width: 90%;

    ${(props) => props.theme.breakpoints.up("tablet")} {
        text-align: left;
        width: 80%;
    }
`;

interface CreditRatingDisclaimerProps {
    description: string;
}

const CreditRatingDisclaimer = ({ cancel, next, description }: StepControls & CreditRatingDisclaimerProps) => {
    return (
        <>
            <Description>{description}</Description>
            <FormButtons onCancel={cancel} onSubmit={next} />
        </>
    );
};

export default CreditRatingDisclaimer;
